/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import './Client.scss';

interface ClientProps {
  profileLink: string;
  name?: string | null;
}

/**
 * This is the Client component.
 *
 * @author Thomas Sømoen <¨>
 */
const Client = ({ profileLink, name }: ClientProps) => {
  if (!name) return null;
  return (
    <div className="client">
      <a href={profileLink}>{name}</a>
    </div>
  );
};

export default Client;
